import { useCallback } from 'react';
import { Key } from 'w3c-keys';
import { stopEvent } from '../utils/event.mjs';
import useListNavigation from './useListNavigation.mjs';

function useListNavigationSelect({
  onItemSelect,
  ...params
}) {
  const [activeIndex, listElementProps] = useListNavigation(params);
  const handleKeyDown = useCallback(
    (event) => {
      const values = params.getListRef().map((item) => item.value);
      const refs = params.getListRef().map((item) => item.ref);
      const activeItem = refs[activeIndex];
      if (event.key === Key.Enter) {
        stopEvent(event, { prevent: true });
        const value = values[activeIndex];
        if (value === void 0) {
          console.warn(
            "[packages/linear] value === undefined \uC778 \uC0C1\uD669\uC774 \uC758\uB3C4\uC778\uC9C0 \uD655\uC778\uD574 \uC8FC\uC138\uC694."
          );
        }
        onItemSelect?.(value);
        activeItem?.current?.click();
        listElementProps.onKeyDown?.(event);
        return;
      }
      listElementProps.onKeyDown?.(event);
    },
    [activeIndex, listElementProps, onItemSelect, params]
  );
  return [
    activeIndex,
    {
      ...listElementProps,
      onKeyDown: handleKeyDown
    }
  ];
}

export { useListNavigationSelect as default };
//# sourceMappingURL=useListNavigationSelect.mjs.map
